import classNames from 'classnames';
import React from 'react';
import { EARLY_WITHDRAWAL_PENALTY_AGE } from 'src/settings/settings';
import styles from './WithholdingPanel.module.scss';
import { isAutomaticSell } from '../../../utils/transactions-util';

export interface WithholdingPanelProps {
  showWithholdingWarning?: boolean;
}
export const WithholdingPanel: React.FC<WithholdingPanelProps> = ({
  showWithholdingWarning,
  children,
}) => {
  return (
    <React.Fragment>
      <article
        className={`${styles['withholding-container']} ${
          isAutomaticSell() ? styles['withholding-auto-container'] : ''
        }`}
      >
        <h4
          className={classNames(
            styles['deduction-label'],
            styles['important'],
            styles['deduction-title']
          )}
        >
          Elect Withholding
        </h4>
        {children}
      </article>
      {showWithholdingWarning && (
        <aside className={classNames(styles['early-withdrawal-warning'])}>
          <h5>Early Withdrawal Warning</h5>
          <p>
            A 10% additional tax for early withdrawal may apply for
            distributions made before reaching age{' '}
            {EARLY_WITHDRAWAL_PENALTY_AGE}.
          </p>
        </aside>
      )}
    </React.Fragment>
  );
};
